import {
  ApiDateFormat,
  BaseModel,
} from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  EInvoiceDocumentType,
  EInvoiceEnvironment,
  EInvoiceState,
  EInvoiceTaxReportState,
  IEInvoiceStatusUpdate,
  IEInvoiceSubmissionView,
  IEInvoicingProviderCapabilities,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class EInvoiceSubmission
  extends BaseModel<EInvoiceSubmission, 'Invoice'>
  implements IEInvoiceSubmissionView
{
  static override readonly modelName: AbilitySubjectType = 'Invoice';

  invoiceId!: string;
  invoice?: { id: string; internalId: string };
  documentNumber!: string;
  provider!: string;
  environment!: EInvoiceEnvironment;
  providerName!: string;
  documentType!: EInvoiceDocumentType;
  idempotencyKey!: string;
  providerDocumentId!: string | null;
  senderParticipantId!: string;
  receiverParticipantId!: string;
  state!: EInvoiceState;
  taxReportState!: EInvoiceTaxReportState | null;
  error!: string | null;
  statusUpdates!: IEInvoiceStatusUpdate[];
  xmlSha256!: string;
  @Type(() => Date)
  @ApiDateFormat()
  submittedAt!: Date | null;
  @Type(() => Date)
  @ApiDateFormat()
  finalizedAt!: Date | null;
  @Type(() => Date)
  @ApiDateFormat()
  lastSyncedAt!: Date | null;
  capabilities!: IEInvoicingProviderCapabilities;
  canSync!: boolean;
  canRetry!: boolean;
}
